import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { loadComponent } from '../utils/componentLoader'
import { store } from '../store'
import { fetchProfile } from '../features/auth/authSlice'
import { EmailProvider } from '@/components/EmailLink'

store.dispatch(fetchProfile())

// Automatically mount all components with data-react-component
document.addEventListener('DOMContentLoaded', () => {
  const mountPoints = document.querySelectorAll('[data-react-component]')
  
  mountPoints.forEach(mountPoint => {
    const componentName = mountPoint.dataset.reactComponent
    const props = JSON.parse(mountPoint.dataset.reactProps || '{}')
    
    try {
      const Component = loadComponent(componentName)
      const root = createRoot(mountPoint)

      root.render(
        <Provider store={store}>
          <EmailProvider options={{ showIcon: false }}>
            <Component {...props} />
          </EmailProvider>
        </Provider>
      )
    } catch (err) {
      console.error(`Error loading component ${componentName}:`, err)
    }

  })
})